function Footer() {
  return (
    <div className="Footer">
      <p>Copyright © 2019 <span><a href="https://junocollege.com">Juno College</a></span></p>
    </div>
  );
}
export default Footer;
